// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3BYq8","col":"Table_col__39ViM","fulfillmentStatus":"Table_fulfillmentStatus__3B1Yf","emailCol":"Table_emailCol__CopBO"};